// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ent-payment__step[data-v-4bebefac] {\n  margin-bottom: 70px;\n  padding: 0 117px;\n  text-align: left;\n}\n.ent-payment__field[data-v-4bebefac] {\n  margin-bottom: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
